{
  "hero": {
    "title": "Services",
    "cta": "Get in touch"
  },
  "banner": {
    "message": "I am here for any questions",
    "cta": "Get in touch"
  },
  "services": [
    {
      "number": "01",
      "title": "Video and photography content production",
      "description": "The missing link in modern business. I produce high-quality video and photography that most agencies expect you to provide yourself. I design your website around the content I shoot.",
      "items": [
        {
          "title": "Brand stories",
          "description": "Cinematic videos that humanize your company.",
          "previewVideo": "povesti-brand"
        },
        {
          "title": "Product demo and explainer videos",
          "description": "Making complex tech easy to understand.",
          "previewVideo": "demo-produs"
        },
        {
          "title": "Social-first vertical video",
          "description": "Portrait Reels, Stories, and TikTok cuts produced from the same shoot.",
          "previewVideo": "social-first"
        },
        {
          "title": "Product and lifestyle photography",
          "description": "Professional stills for websites, catalogs, e-commerce, and campaigns.",
          "previewVideo": "fotografie-produs"
        },
        {
          "title": "On-location and event coverage",
          "description": "Filming at your office, store, vineyard, or live event.",
          "previewVideo": "filmari-on-location"
        },
        {
          "title": "Asset libraries",
          "description": "A monthly bank of professional photos and short-form video to keep your channels active."
        }
      ]
    },
    {
      "number": "02",
      "title": "Brand engineering",
      "description": "From the first sketch to the final deploy. I don't believe in \"disconnected\" branding. I build your visual identity and your digital storefront as a single, living organism.",
      "items": [
        {
          "title": "Identity design",
          "description": "Logos, typography, and brand books that translate to the web."
        },
        {
          "title": "High-performance web development",
          "description": "Custom-coded websites built for conversion and speed."
        },
        {
          "title": "Content-driven websites",
          "description": "Sites structured around the photos and videos we produce together."
        },
        {
          "title": "Landing pages and campaign microsites",
          "description": "Focused pages for launches, ads, partnerships, and lead generation."
        },
        {
          "title": "Digital ecosystems",
          "description": "Ensuring your brand feels the same on a smartphone as it does on a desktop."
        },
        {
          "title": "Visual content updates",
          "description": "Refreshing your site with new product photos, videos, and seasonal campaigns."
        }
      ]
    }
  ]
}
